import {
  WmModal,
  WmModalFooter,
  WmModalHeader
} from "@watermarkinsights/ripple-react";
import { useIntl } from "react-intl";
import translate from "../../i18n/translate";
import { useContext } from "react";
import { AppContext, AppContextInterface } from "@/contexts/AppContext";

export default function PreviewModal(): JSX.Element {
  const { closePreviewModal, componentLoaded } =
    useContext<AppContextInterface>(AppContext);

  const previewModalPrimaryBtn = useIntl().formatMessage({
    id: "app.lightcast.previewModalPrimaryBtn"
  });
  const previewModalHeading = useIntl().formatMessage({
    id: "app.lightcast.previewModalHeading"
  });

  return (
    <div id="preview-modal">
      <WmModal
        open={componentLoaded.openPreviewModal}
        id="my-preview-modal"
        elementToFocus="primary"
        modalType="dialog"
        uid="my-preview-modal"
        onWmModalCloseTriggered={closePreviewModal}
        onWmModalPrimaryTriggered={closePreviewModal}
      >
        <WmModalHeader heading={previewModalHeading}></WmModalHeader>
        <div className="modal-content body" id="content-preview-model">
          <div className="preview-content">
            <div className="para-text">
              {translate("app.lightcast.previewModalPara1")}
            </div>
            <div className="para-text">
              {translate("app.lightcast.previewModalPara2")}
            </div>
          </div>
        </div>
        <WmModalFooter
          primaryText={previewModalPrimaryBtn}
          deleteStyle={false}
        ></WmModalFooter>
      </WmModal>
    </div>
  );
}
